import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

const ThankYouCard = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate("/");
  };

  return (
    <CardContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <Emoji>🎉</Emoji>
        <Title>Thank you for connecting!</Title>
      </div>
      <SubText>
        Our team will reach out to you shortly to help elevate your workflow.
      </SubText>
      <BackButton onClick={handleBackHome}>Back to Home</BackButton>
    </CardContainer>
  );
};

export default ThankYouCard;

// Styled Components
const CardContainer = styled(motion.div)`
  max-width: 500px;
  margin: 100px auto;
  padding: 2rem;
  background-color: white;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);

  @media (max-width: 480px) {
    margin: 50px 20px;
    padding: 1.5rem;
  }
`;

const Emoji = styled.div`
  font-size: 2.5rem;
`;

const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  font-family: "Inter", sans-serif;
`;

const SubText = styled.p`
  font-size: 1rem;
  color: #4b5563;
  margin-bottom: 1.5rem;
  font-family: "Inter", sans-serif;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #2563eb;
  font-size: 1rem;
  cursor: pointer;
  text-decoration: underline;
  font-family: "Inter", sans-serif;

  &:hover {
    color: #1d4ed8;
  }
`;
